<script>
	import collect from 'collect.js';
	import { BetType } from '@/Constants/Bet.js';
	import RaceResultSelection from './_RaceResultSelection.svelte';
	import { NumberFormat } from '@/Services/Helpers';

	export let results;
	export let race;

	$: placings = results && getPlacings();
	$: placingProducts = placings && getPlacingProducts();
	$: exotics = results && getExotics();

	function getPlacings() {
		if (results && results.placings.length) {
			return collect(results.placings);
		}
		return false;
	}

	function getPlacingProducts() {
		if (placings && placings.count()) {
			return collect(placings.first().dividends);
		}
		return false;
	}

	function getExotics() {
		if (results && results.exotics.length) {
			return collect(results.exotics);
		}
		return false;
	}

	/**
	 * We need it formated like this:
	 * (1,2,3,4)
	 * (1/2,3,4) for tied positions
	 * Quinella: (1/2)
	 */
	function formatExotics(results) {
		let display;
		let count = results.selections.length;
		for (let index = 0; index < count; index++) {
			if (index === 0) {
				display = results.selections[index].selection_number;
			} else {
				let prevPosition = results.selections[index - 1].position;
				let currentPosition = results.selections[index].position;
				let separator = prevPosition === currentPosition || results.bet_type.id === BetType.Quinella ? '/' : ',';
				display += separator + results.selections[index].selection_number;
			}
		}
		return display;
	}
</script>

{#if placings && placingProducts}
	<div>
		<div class="table w-full text-sm text-center table-auto">
			<div class="table-row-group">
				<div class="table-row font-bold uppercase">
					<div class="table-cell pl-2 text-left align-middle">Winners</div>
					{#each placingProducts.where('bet_type.id', 2).all() as product}
						<div class="table-cell px-1 align-middle">
							{product.product.name}
						</div>
					{/each}
				</div>
			</div>
			<div class="table-row-group text-sm text-dark-grey">
				{#each placings.sortBy('position').all() as place}
					<!-- WINNER RESULTS -->
					{#if parseInt(place.position) === 1}
						<div class="table-row">
							<div class="table-cell pl-2 text-left border-b border-row-separator">
								<RaceResultSelection {race} {place} />
							</div>
							{#each collect(place.dividends).where('bet_type.id', 2).all() as dividend}
								<div class="table-cell py-2 font-bold border-b border-row-separator">
									{NumberFormat(dividend.value, false, false)}
								</div>
							{/each}
						</div>
					{/if}
					<!-- PLACE RESULTS -->
					<div class="table-row">
						<div class="table-cell pl-2 text-left border-b border-row-separator">
							{#if parseInt(place.position) > 1}
								<RaceResultSelection {race} {place} />
							{/if}
						</div>
						{#each collect(place.dividends).where('bet_type.id', 3).all() as dividend}
							<div class="table-cell py-2 font-bold border-b border-row-separator">
								{dividend.value > 0 ? NumberFormat(dividend.value, false, false) : '-'}
							</div>
						{/each}
					</div>
				{/each}
			</div>
		</div>
		<!-- EXOTIC RESULTS -->
		{#if exotics}
			<div class="table w-full mt-1 text-sm table-auto">
				<div class="table-row-group">
					<div class="table-row uppercase">
						<div class="table-cell" />
						<div class="table-cell mt-1 font-bold text-center uppercase align-middle">Exotics</div>
						<div class="table-cell" />
					</div>
					{#each exotics.all() as result}
						<div class="table-row text-dark-grey">
							<div class="table-cell w-full py-1 text-right align-middle border-b border-row-separator">
								<div class="">
									{result.product.name} - {result.bet_type.name}
								</div>
							</div>
							<div class="table-cell text-right align-middle border-b border-row-separator">
								<div class="px-4">({formatExotics(result)})</div>
							</div>
							<div class="table-cell py-1 text-center align-middle border-b border-row-separator">
								<div class="mr-2 whitespace-nowrap flex flex-col justify-end items-end">
									<span class="font-bold text-base">
										{result.value > 0 ? NumberFormat(result.value, false, false) : '-'}
									</span>
									<span class="font-normal text-xs">
										P: {result.prize_pool > 0 ? NumberFormat(result.prize_pool, false, false) : '-'}
									</span>
								</div>
							</div>
						</div>
					{/each}
				</div>
			</div>
		{/if}
	</div>
{/if}
